export const defaultFaqVal =  [{ question: '', answer: '' }]
export const defaultScholarShipOppVal = { emiEnabled:"yes", eligibility:[], overview: ""}
export const defaultEmiFinancialAidVal = {emiEnabled:"yes",
    zeroInterest: false,
    tenure:"",
    partnersId:[],
    overview:"",
  }